import {
    DesktopOutlined,
    CodeOutlined,
    LayoutOutlined,
    BulbOutlined,
    RocketOutlined,
    CheckCircleOutlined,
} from '@ant-design/icons';
import React from 'react';

export const portfolioDetail = {
    title: 'Portfolio Website - Trang giới thiệu cá nhân',
    description: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Tổng quan</h2>
            <p className="mb-4">
                Website Portfolio cá nhân là một dự án được thiết kế để giới thiệu bản thân, các kỹ năng và dự án của
                tôi một cách ấn tượng và chuyên nghiệp. Trang web này không chỉ là một bản lý lịch trực tuyến mà còn là
                một nền tảng thể hiện phong cách và cá tính riêng, đồng thời trình bày chi tiết về các dự án tôi đã tham
                gia.
            </p>
            <p className="mb-4">
                Được phát triển với ReactJS, Tailwind CSS và SCSS, website sử dụng các thư viện animation hiện đại như
                GSAP và Framer Motion để tạo ra những trải nghiệm tương tác mượt mà và ấn tượng. Thiết kế responsive đảm
                bảo trang web hiển thị tốt trên mọi thiết bị từ máy tính để bàn đến điện thoại di động.
            </p>
            <p className="mb-4">
                Quá trình xây dựng trang portfolio này là cơ hội để tôi áp dụng các kỹ năng frontend mới nhất và thể
                hiện khả năng thiết kế UI/UX, đồng thời tạo ra một công cụ hiệu quả để kết nối với các nhà tuyển dụng
                tiềm năng và đồng nghiệp trong ngành.
            </p>

            <div className="mb-6">
                <img
                    src="/assets/images/projects/portfolio/thumbnail.jpg"
                    alt="Portfolio Website"
                    className="w-full rounded-lg shadow-md"
                />
                <p className="text-sm text-gray-600 italic mt-2 text-center">Giao diện trang chủ của Portfolio</p>
            </div>

            <h3 className="text-xl font-semibold mb-3 mt-6">Các đặc điểm nổi bật</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                    <h4 className="font-semibold text-blue-700 mb-2">Thiết kế hiện đại</h4>
                    <p className="text-sm text-gray-700">
                        Giao diện tối giản nhưng tinh tế với sự kết hợp hài hòa giữa màu sắc, phông chữ và khoảng trắng.
                    </p>
                </div>

                <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                    <h4 className="font-semibold text-green-700 mb-2">Hiệu ứng animation</h4>
                    <p className="text-sm text-gray-700">
                        Các hiệu ứng cuộn trang, chuyển đổi và tương tác được thiết kế mượt mà, tạo trải nghiệm người
                        dùng tốt.
                    </p>
                </div>

                <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                    <h4 className="font-semibold text-purple-700 mb-2">Responsive design</h4>
                    <p className="text-sm text-gray-700">
                        Hoạt động hoàn hảo trên mọi kích thước màn hình và thiết bị, từ desktop đến mobile.
                    </p>
                </div>

                <div className="bg-amber-50 p-4 rounded-lg border-l-4 border-amber-500">
                    <h4 className="font-semibold text-amber-700 mb-2">Trình bày dự án chi tiết</h4>
                    <p className="text-sm text-gray-700">
                        Mỗi dự án được trình bày với hình ảnh, mô tả, công nghệ sử dụng và liên kết đến live demo.
                    </p>
                </div>
            </div>
        </>
    ),
    technologies: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Công nghệ sử dụng</h2>

            <div className="space-y-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <CodeOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Frontend & UI</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/react-2.svg" alt="ReactJS" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">ReactJS</span>
                                <span className="text-xs text-gray-500 mt-1">Framework</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/tailwind-css.png" alt="Tailwind CSS" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">Tailwind CSS</span>
                                <span className="text-xs text-gray-500 mt-1">Styling</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/sass.png" alt="SCSS" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">SCSS</span>
                                <span className="text-xs text-gray-500 mt-1">Preprocessor</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/antd.svg" alt="Ant Design" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">Ant Design</span>
                                <span className="text-xs text-gray-500 mt-1">UI Components</span>
                            </div>

                            <div className="bg-blue-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/redux.svg" alt="Redux Toolkit" className="w-6 h-6" />
                                </div>
                                <span className="font-medium text-gray-800">Redux Toolkit</span>
                                <span className="text-xs text-gray-500 mt-1">State Management</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-4 flex items-center">
                        <div className="w-10 h-10 flex-shrink-0 bg-white rounded-full flex items-center justify-center mr-4">
                            <RocketOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-xl font-bold text-white">Tools & Deployment</h3>
                    </div>

                    <div className="p-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/git.png" alt="Git" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Git</span>
                                <span className="text-xs text-gray-500 mt-1">Version Control</span>
                            </div>

                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/vercel.svg" alt="Vercel" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">Vercel</span>
                                <span className="text-xs text-gray-500 mt-1">Deployment</span>
                            </div>

                            <div className="bg-purple-50 rounded-lg p-4 text-center hover:shadow-md transition-shadow duration-300 flex flex-col items-center justify-center">
                                <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm mb-3">
                                    <img src="/assets/logos/vscode.jpeg" alt="VS Code" className="w-8 h-8" />
                                </div>
                                <span className="font-medium text-gray-800">VS Code</span>
                                <span className="text-xs text-gray-500 mt-1">Code Editor</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    features: () => (
        <>
            <h2 className="text-2xl font-bold mb-6">Tính năng chính</h2>

            <div className="space-y-6">
                <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                    <div className="p-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                    <LayoutOutlined className="text-blue-600" />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Trang chủ ấn tượng</h4>
                                    <p className="text-gray-700">
                                        Hero section với animation text hiển thị kỹ năng và thông tin giới thiệu ngắn
                                        gọn, tạo ấn tượng mạnh mẽ ngay từ đầu.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                                    <BulbOutlined className="text-green-600" />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Danh mục dự án</h4>
                                    <p className="text-gray-700">
                                        Trình bày các dự án đã thực hiện với hình ảnh, mô tả ngắn gọn và các công nghệ
                                        sử dụng, kèm liên kết đến demo và source code.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                                    <CodeOutlined className="text-purple-600" />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Phần kỹ năng</h4>
                                    <p className="text-gray-700">
                                        Hiển thị các kỹ năng kỹ thuật và công nghệ thành thạo với biểu diễn trực quan về
                                        mức độ thành thạo.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <div className="flex-shrink-0 w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mr-4">
                                    <DesktopOutlined className="text-amber-600" />
                                </div>
                                <div>
                                    <h4 className="font-semibold text-lg mb-1">Responsive design</h4>
                                    <p className="text-gray-700">
                                        Trang web được tối ưu hóa cho mọi kích thước màn hình, đảm bảo trải nghiệm người
                                        dùng tốt trên desktop, tablet và mobile.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    ),
    results: () => (
        <>
            <h2 className="text-2xl font-bold mb-4">Kết quả đạt được</h2>

            <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <CheckCircleOutlined className="text-blue-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Thể hiện kỹ năng</h3>
                        <p className="text-gray-700">
                            Chứng minh năng lực thiết kế và phát triển frontend thông qua chính website
                        </p>
                    </div>

                    <div className="bg-green-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <CheckCircleOutlined className="text-green-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Nền tảng trình bày dự án</h3>
                        <p className="text-gray-700">Trình bày chi tiết và sinh động các dự án đã thực hiện</p>
                    </div>

                    <div className="bg-purple-50 p-4 rounded-lg text-center">
                        <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <CheckCircleOutlined className="text-purple-600 text-xl" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-2">Công cụ marketing cá nhân</h3>
                        <p className="text-gray-700">Tạo điểm khác biệt trong hồ sơ ứng tuyển và networking</p>
                    </div>
                </div>
            </div>
        </>
    ),
    screenshots: [
        {
            url: '/assets/images/projects/portfolio/thumbnail.jpg',
            caption: 'Trang chủ Portfolio',
        },
    ],
    teamSize: 1,
    duration: '1 tuần',
    role: 'Frontend Developer',
    architecture: 'Single Page Application',
    responsibilities: [
        'Thiết kế và phát triển toàn bộ website',
        'Xây dựng giao diện responsive với Tailwind CSS và SCSS',
        'Tạo hiệu ứng animation với GSAP và Framer Motion',
        'Quản lý state với Redux Toolkit',
        'Tối ưu hóa hiệu suất',
        'Triển khai website trên Vercel',
    ],
};
